import { render, staticRenderFns } from "./indicadores_unidad_medidas.vue?vue&type=template&id=4cf10534&"
import script from "./indicadores_unidad_medidas.vue?vue&type=script&lang=ts&"
export * from "./indicadores_unidad_medidas.vue?vue&type=script&lang=ts&"
import style0 from "./indicadores_unidad_medidas.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports